import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import { Grid, useMediaQuery, useTheme } from '@mui/material';

const FAQFormArea = () => {
	const [step, setStep] = useState(1);
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const [formData, setFormData] = useState({
		fullName: '',
		email: '',
		phone: '',
		workType: '',
		category: '',
		otherServices: '',
		consultation: '',
	});

	const handleNext = () => setStep((prev) => prev + 1);
	const handlePrev = () => setStep((prev) => prev - 1);
	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		alert('Form submitted! Data: ' + JSON.stringify(formData));
	};

	// Animation for the form step transitions
	const animationProps = useSpring({
		opacity: step === 1 ? 1 : 0,
		transform: step === 1 ? 'translateY(0)' : 'translateY(-20px)',
	});

	// Recalculate animation for each step, adjust for visibility
	const getAnimationProps = (currentStep) => ({
		opacity: step === currentStep ? 1 : 0,
		transform: step === currentStep ? 'translateY(0)' : 'translateY(-20px)',
		config: { tension: 300, friction: 20 },
	});

	return (
		<div
			className='container'
			style={{ marginTop: 50, padding: matches ? 30 : 80 }}>
			<Grid container spacing={2}>
				<Grid item xs={12} lg={6}>
					<div className='faq-section'>
						<h2 style={{ fontWeight: 'bold' }}>Frequently Asked Questions</h2>
						<ul>
							{[
								'What is the lowest price for web development?',
								'What are the best development services you offer?',
								'Do you provide post-delivery services?',
								'Is it possible to put my old website in a google listing?',
								'How many days of support will be provided by us after a project is delivered?',
								'What is the cost of Branding?',
							].map((question, idx) => (
								<li key={idx} style={{ fontSize: 20 }}>
									{question}
								</li>
							))}
						</ul>
					</div>
				</Grid>
				<Grid item xs={12} lg={6}>
					<div className='form-section'>
						<h2>Get a Quote</h2>
						<div className='steps' style={{ marginTop: 10 }}>
							{(matches
								? ['Contact details']
								: [
										'Contact details',
										'Type of work',
										'Category',
										'Other Services',
										'Meeting',
								  ]
							).map((label, index) => (
								<div
									key={index}
									className={`step ${step === index + 1 ? 'active' : ''}`}>
									<div className='circle' style={{ marginBottom: 10 }}>
										{index + 1}
									</div>
									<span className='label' style={{ fontSize: 10 }}>
										{label}
									</span>
								</div>
							))}
						</div>

						<form onSubmit={handleSubmit}>
							{step === 1 && (
								<animated.div
									style={getAnimationProps(1)}
									className='form-step'>
									<h4>Please give us your contact details</h4>
									<p>
										Keep an eye out for your quote from Kre8iveminds - don't
										forget to check your spam folder just in case.
									</p>
									<input
										type='text'
										name='fullName'
										placeholder='Your full name'
										value={formData.fullName}
										onChange={handleChange}
										required
									/>
									<input
										type='email'
										name='email'
										placeholder='Your email'
										value={formData.email}
										onChange={handleChange}
										required
									/>
									<input
										type='tel'
										name='phone'
										placeholder='Your mobile number'
										value={formData.phone}
										onChange={handleChange}
										required
									/>
									<button
										type='button'
										onClick={handleNext}
										style={{background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)'}}
										className='next-button'>
										Next
									</button>
								</animated.div>
							)}

							{step === 2 && (
								<animated.div
									style={getAnimationProps(2)}
									className='form-step'>
									<h4>What type of work do you require?</h4>
									<input
										type='text'
										name='workType'
										placeholder='Type of work'
										value={formData.workType}
										onChange={handleChange}
										required
									/>
									<button
										type='button'
										onClick={handlePrev}
										style={{background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)'}}
										className='prev-button'>
										Previous
									</button>
									<button
									
										type='button'
										onClick={handleNext}
										style={{ marginTop: 10 , background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)'}}
										className='next-button'>
										Next
									</button>
								</animated.div>
							)}

							{step === 3 && (
								<animated.div
									style={getAnimationProps(3)}
									className='form-step'>
									<h4>What category of work do you require?</h4>
									<input
										type='text'
										name='category'
										placeholder='Category'
										value={formData.category}
										onChange={handleChange}
										required
									/>
									<button
										type='button'
										onClick={handlePrev}
										style={{background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)'}}
										className='prev-button'>
										Previous
									</button>
									<button
										style={{ marginTop: 10 , background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)'}}
										type='button'
										onClick={handleNext}
										
										className='next-button'>
										Next
									</button>
								</animated.div>
							)}

							{step === 4 && (
								<animated.div
									style={getAnimationProps(4)}
									className='form-step'>
									<h4>Do you need any other services?</h4>
									<input
										type='text'
										name='otherServices'
										placeholder='Other services'
										value={formData.otherServices}
										onChange={handleChange}
										required
									/>
									<button
										type='button'
										onClick={handlePrev}
										style={{background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)'}}
										className='prev-button'>
										Previous
									</button>
									<button
										
										type='button'
										onClick={handleNext}
										style={{ marginTop: 10 , background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)' }}
										className='next-button'>
										Next
									</button>
								</animated.div>
							)}

							{step === 5 && (
								<animated.div
									style={getAnimationProps(5)}
									className='form-step'>
									<h4>Would you like a face-to-face consultation?</h4>
									<label>
										<input
											type='radio'
											name='consultation'
											value='yes'
											onChange={handleChange}
										/>
										Yes
									</label>
									<label>
										<input
											type='radio'
											name='consultation'
											value='no'
											onChange={handleChange}
										/>
										No
									</label>
									<button
										type='button'
										onClick={handlePrev}
										style={{background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)'}}
										className='prev-button'>
										Previous
									</button>
									<button
										type='submit'
										className='submit-button'
										
										style={{ marginTop: 10 , background:'linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)' }}>
										Submit
									</button>
								</animated.div>
							)}
						</form>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default FAQFormArea;
